import React from "react"

export const withImage = Component => ({ name = "Image", image, ratio = "", link = {}, alt: externalAlt = "", ...rest }) => {
  const fluid = ratio && typeof ratio === "string" ? { ...image, aspectRatio: Number(ratio?.split("/")[0]) / Number(ratio?.split("/")[1]) } : image
  const { alt } = image || {}
  Component.displayName = name
  return <Component image={fluid} link={link} alt={externalAlt ? externalAlt : alt} {...rest} />
}
